// Global variables to store separate media sets
window.galleryMediaSet = [];
window.referenceMediaSet = [];

// Update both media sets
function updateMediaSets() {
  window.galleryMediaSet = createGalleryMediaSet();
  window.referenceMediaSet = createReferenceMediaSet();
}

// Expose globally
window.updateMediaSets = updateMediaSets;

export function initializeTrixImages() {
  // Create and store the separate media sets globally
  updateMediaSets();
  // Handle caption clicks
  document.querySelectorAll('.trix-image-caption-link').forEach(link => {
    link.addEventListener('click', handleCaptionClick);
  });

  // Handle inline thumbnail clicks
  document.querySelectorAll('.trix-inline-thumbnail').forEach(thumbnail => {
    thumbnail.addEventListener('click', handleInlineThumbnailClick);
  });

  // Handle YouTube video clicks in references section
  document.querySelectorAll('.reference-youtube-thumbnail').forEach(thumbnail => {
    thumbnail.addEventListener('click', handleYouTubeReferenceClick);
  });

  // Handle thumbnail clicks (references section)
  document.querySelectorAll('.trix-image-thumbnail').forEach(thumbnail => {
    thumbnail.addEventListener('click', handleThumbnailClick);
  });
}

function handleCaptionClick(event) {
  event.preventDefault();
  event.stopPropagation();
  
  const imageIndex = parseInt(this.dataset.imageIndex);
  const imageId = this.dataset.imageId;
  const captionText = this.textContent.replace(/^\s*🖼️\s*/, '').replace(/^\d+\s*/, ''); // Remove emoji and footnote number
  
  // Use the reference media set and find the image
  let targetIndex = -1;
  
  // Try to find the image in the reference media set
  for (let i = 0; i < window.referenceMediaSet.length; i++) {
    if (window.referenceMediaSet[i].type === 'image') {
      const element = window.referenceMediaSet[i].element;
      if ((element.dataset && element.dataset.imageId === imageId) || 
          (element.closest && element.closest(`[data-image-id="${imageId}"]`))) {
        targetIndex = i;
        break;
      }
    }
  }
  
  if (targetIndex !== -1 && window.showLightboxImage) {
    window.showLightboxImage('', targetIndex, window.referenceMediaSet, captionText);
  }
}

function handleInlineThumbnailClick(event) {
  event.preventDefault();
  event.stopPropagation();
  
  const imageUrl = this.dataset.full || this.src;
  
  // Find this image in the reference media set
  const targetIndex = window.referenceMediaSet.findIndex(item => 
    item.type === 'image' && 
    (item.url === imageUrl || item.element === this)
  );
  
  if (targetIndex !== -1 && window.showLightboxImage) {
    const caption = window.referenceMediaSet[targetIndex].caption;
    window.showLightboxImage('', targetIndex, window.referenceMediaSet, caption);
  }
}

function handleYouTubeReferenceClick(event) {
  event.preventDefault();
  event.stopPropagation();
  
  const videoUrl = this.dataset.youtube_url || this.dataset.youtubeUrl;
  
  // Find this video in the reference media set
  const videoIndex = window.referenceMediaSet.findIndex(item => 
    item.type === 'youtube' && 
    (item.url === videoUrl || item.element === this)
  );
  
  if (window.showLightboxImage && videoIndex !== -1) {
    const caption = window.referenceMediaSet[videoIndex].caption;
    window.showLightboxImage('', videoIndex, window.referenceMediaSet, caption);
  }
}

function createGalleryMediaSet() {
  const mediaSet = [];
  
  // Add only main gallery images (figure images at top of page).
  // Skip [data-no-lightbox] images (placeholders, etc.) so they aren't
  // included in the navigable media set.
  document.querySelectorAll('#gallery img:not([data-no-lightbox])').forEach((img, index) => {
    const webpUrl = img.dataset.fullWebp || img.dataset.full_webp || img.dataset.full || img.src;
    const avifUrl = img.dataset.fullAvif || img.dataset.full_avif || null;
    const caption = img.dataset.caption || '';

    mediaSet.push({
      type: 'image',
      url: webpUrl,
      avifUrl: avifUrl,
      caption: caption,
      element: img
    });
  });
  
  return mediaSet;
}

function createReferenceMediaSet() {
  const mediaSet = [];
  const seenUrls = new Set(); // Track URLs to avoid ALL duplicates (images and videos)
  
  // Add images from inline thumbnails
  document.querySelectorAll('.trix-inline-thumbnail').forEach((thumbnail, index) => {
    // Only include if element is visible (not in collapsed state)
    if (thumbnail.offsetParent === null) return;
    
    const fullUrl = thumbnail.dataset.full || thumbnail.src;

    // Skip if we've already seen this image URL
    if (seenUrls.has(fullUrl)) return;
    seenUrls.add(fullUrl);
    
    // Find the associated caption link
    const container = thumbnail.closest('.trix-inline-image-container');
    const captionLink = container ? container.querySelector('.trix-image-caption-link') : null;
    let caption = thumbnail.alt;
    
    if (captionLink) {
      // Extract caption text, removing icon and footnote
      caption = captionLink.textContent.replace(/^\s*🖼️\s*/, '').replace(/^\d+\s*/, '').trim();
    }
    
    mediaSet.push({
      type: 'image',
      url: fullUrl,
      caption: caption,
      element: thumbnail
    });
  });
  
  // Add images from reference thumbnails (using same URL deduplication)
  document.querySelectorAll('.trix-image-thumbnail').forEach((thumbnail, index) => {
    // Only include if element is visible (not in collapsed state)
    if (thumbnail.offsetParent === null) return;
    
    const img = thumbnail.querySelector('img');
    if (img) {
      const fullUrl = img.dataset.full || img.src;

      // Skip if we've already seen this image URL
      if (seenUrls.has(fullUrl)) return;
      seenUrls.add(fullUrl);
      
      // Get caption from the thumbnail card content - use a more specific selector to avoid the numbered badge
      const captionElement = thumbnail.querySelector('.flex.flex-col.flex-1 .text-white.font-semibold');
      const caption = captionElement ? captionElement.textContent.trim() : (img.alt || 'Reference Image');
      
      mediaSet.push({
        type: 'image',
        url: fullUrl,
        caption: caption,
        element: img
      });
    }
  });
  
  // Add YouTube videos from reference thumbnails (using same URL deduplication)
  document.querySelectorAll('.reference-youtube-thumbnail').forEach((thumbnail, index) => {
    // Only include if element is visible (not in collapsed state)
    if (thumbnail.offsetParent === null) return;
    
    const videoUrl = thumbnail.dataset.youtube_url || thumbnail.dataset.youtubeUrl;
    
    // Skip if we've already seen this video URL
    if (seenUrls.has(videoUrl)) return;
    seenUrls.add(videoUrl);
    
    mediaSet.push({
      type: 'youtube',
      url: videoUrl,
      caption: thumbnail.dataset.youtube_title || thumbnail.dataset.youtubeTitle,
      element: thumbnail
    });
  });
  
  return mediaSet;
}

function handleThumbnailClick(event) {
  event.preventDefault();
  event.stopPropagation();
  
  const imageId = this.dataset.imageId;
  const img = this.querySelector('img');
  
  if (img) {
    const imageUrl = img.dataset.full || img.src;

    // Find this image in the reference media set
    const targetIndex = window.referenceMediaSet.findIndex(item => 
      item.type === 'image' && 
      (item.url === imageUrl || item.element === img || (item.element.dataset && item.element.dataset.imageId === imageId))
    );
    
    if (targetIndex !== -1 && window.showLightboxImage) {
      const caption = window.referenceMediaSet[targetIndex].caption;
      window.showLightboxImage('', targetIndex, window.referenceMediaSet, caption);
    }
  }
}

// Initialize on both DOMContentLoaded and turbo:load
document.addEventListener('DOMContentLoaded', initializeTrixImages);
document.addEventListener('turbo:load', initializeTrixImages); 